<template>
  <div class="login">
    <el-card class="box-card">
      <div slot="header" class="clearfix" :style="{ 'color': headerBg }">
        云智创新
      </div>
      <el-form ref="ruleForm"
               :model="ruleForm"
               class="ruleForm">
        <el-form-item prop="account">
          <el-input v-model.number="ruleForm.account"
                    placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item prop="password" style="margin-top: 20px;">
          <el-input v-model="ruleForm.password"
                    type="password"
                    autocomplete="off"
                    show-password
                    placeholder="请输入密码"
                    @keyup.enter.native="submitForm('ruleForm')" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="submitForm" :loading="btn_loading">登录</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { login, checkWeakPassword, getMemberInfo, getUnitInfo } from '@/api/common.js'
import { mapGetters } from 'vuex'
import throttle from 'lodash/throttle'
export default {
  name: 'Login',
  computed: {
    ...mapGetters(['headerBg'])
  },
  data () {
    return {
      btn_loading: false,
      ruleForm: {
        account: '',
        password: ''
      }
    }
  },
  methods: {

    submitForm: throttle(function() {
      this.btn_loading = true
      login({ 'account': this.ruleForm.account, 'password': this.ruleForm.password }).then(res => {

        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.token)
          this.getUnitInfo()
          //获取用户信息并存储本地
          this.getUserInfo().then(res => {
            //获取菜单
            this.getMenu().then(res => {
              this.$router.push('/')
              this.$toast.success('登录成功')
            })
            // setTimeout(() => {
            //   //检查密码强度
            //   this.checkPass(this.ruleForm.password)
            // }, 500);
          })
        } else {
          this.$toast.warning(res.msg ? res.msg : '服务异常')
          this.btn_loading = false
        }

      })
    }, 1500),
    getUserInfo () {
      return new Promise((resolve, reject) => {
        getMemberInfo().then(res => {
          if (res.code == 200) {
            this.$store.commit('userInfo/changeValue', { key: 'userInfo', value: res.data.item })
            resolve(res)
          } else {
            this.$toast.warning(res.msg ? res.msg : '服务异常')
          }
        })
      })
    },
    getUnitInfo () {
      getUnitInfo().then(res => {
        if (res.code == 200) {
          localStorage.setItem('unitInfo', JSON.stringify(res.data.item))
        }
      })
    },
    getMenu () {
      return new Promise((resolve, reject) => {
        let temp =[
      {
        "name": "/",
        "path": "/",
        "hidden": false,
        "redirect": "noRedirect",
        "alwaysShow": true,
        "meta": {
          "title": "首页",
          "icon": 'local',
          "noCache": false,
          "link": null
        },
      },
      {
        "name": "/templateMsg",
        "path": "",
        "hidden": false,
        "alwaysShow": true,
        "meta": {
          "title": "模板管理",
          "icon": 'local',
          "noCache": false,
          "link": null
        },
        children: [
          {
            "name": "/templateType",
            "path": "/templateType",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "模板分类",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/templateMag",
            "path": "/templateMag",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "表单管理",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
        ]
      },
      {
        "name": "/design",
        "path": "",
        "hidden": false,
        "alwaysShow": true,
        "meta": {
          "title": "流程管理",
          "icon": 'local',
          "noCache": false,
          "link": null
        },
        children: [
          {
            "name": "/formDesign",
            "path": "/formDesign",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "表单设计",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/processDesign",
            "path": "/processDesign",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "流程设计",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/startProcess",
            "path": "/startProcess",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "发起流程",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/changePass",
            "path": "/changePass",
            "hidden": true,
            "alwaysShow": true,
            "meta": {
              "title": "修改密码",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
        ]
      },
      {
        "name": "/oaSystem",
        "path": "/oaSystem",
        "hidden": false,
        "redirect": "noRedirect",
        "alwaysShow": true,
        "meta": {
          "title": "系统设置",
          "icon": 'local',
          "noCache": false,
          "link": null
        },
      },
      {
        "name": "/personal",
        "path": "/personal",
        "hidden": true,
        "alwaysShow": true,
        "meta": {
          "title": "个人主页",
          "icon": 'local',
          "noCache": false,
          "link": null
        },
      },
      {
        "name": "/orgModel",
        "path": "",
        "hidden": false,
        "redirect": "noRedirect",
        "alwaysShow": true,
        "meta": {
          "title": "组织机构",
          "icon": 'local',
          "noCache": false,
          "link": null
        },
        children: [
          {
            "name": "/orgWork",
            "path": "/orgWork",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "岗位",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/jobMag",
            "path": "/jobMag",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "职务级别",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/workExtent",
            "path": "/workExtent",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "工作范围",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/departmentMag",
            "path": "/departmentMag",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "部门管理",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/peopleMag",
            "path": "/peopleMag",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "人员管理",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/groupingMag",
            "path": "/groupingMag",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "分组管理",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
          {
            "name": "/roleMag",
            "path": "/roleMag",
            "hidden": false,
            "alwaysShow": true,
            "meta": {
              "title": "角色管理",
              "icon": 'local',
              "noCache": false,
              "link": null
            },
          },
        ]
      },
      {
        "name": "/MenuMag",
        "path": "/MenuMag",
        "hidden": false,
        "alwaysShow": true,
        "meta": {
          "title": "菜单管理",
          "icon": 'local',
          "noCache": false,
          "link": null
        },
      },
      {
        "name": "/DataDic",
        "path": "/DataDic",
        "hidden": false,
        "alwaysShow": true,
        "meta": {
          "title": "数据字典管理",
          "icon": 'local',
          "noCache": false,
          "link": null
        },
      },

    ]

        this.$store.commit('menu/changeValue', { key: 'menuData', value: temp })
        resolve(temp)
      })

    },
    checkPass (password) {
      checkWeakPassword({ 'password': password }).then(res => {
        if (res.code == 200) {
          if (res.data.is_weak) {
            this.$toast.warning('检测到密码强度为弱密码,即将跳转到密码修改页面')
            this.$router.push('/changePass')
          }
        } else {
          this.$toast.warning(res.msg ? res.msg : '服务异常')
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style scoped>
.login {
  height: 100%;
  display: flex;
}

.box-card {
  min-width: 260px;
  width: 388px;
  margin: 0 auto;
  padding: 10px 30px;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 25%;
  right: 15%;
}

.ruleForm {
  text-align: center;
}

.el-card__header {
  text-align: center;
  height: 48px;
  border-bottom: none;
  /* margin-bottom: 40px; */
  background: #fff !important;
}

.line {
  width: 140px;
  margin: 0 auto;
  border-bottom: 2px solid #1890ff;
}

.clearfix {
  padding: 12px 16px;
  font-size: 18px;
  line-height: 45px;
  font-family: "Microsoft YaHei";
  font-weight: 500;
  color: #1890ff;
  text-align: center;
}

.el-input {
  width: 328px;
}

.el-input__inner {
  height: 42px;
}

.el-button {
  margin: 20px 20px 10px 20px;
  width: 120px;
}

/deep/ .el-card__header {
  padding: 5px 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue